import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Helper from '../../inc/Helper';
import $ from 'jquery';
import Form_gui_ids from '../../inc/Form_gui_ids'; 
import LabelsGUI_ID from '../../inc/LabelsGUI_ID'; 
class Sidebar extends Component {
    constructor(props){
        super(props);
        this.state = {
            menu:[]
        }
    }
    componentDidMount(){
        //Helper.makeSticky('.sidebar_section_inner')
    } 

    // {security.canView( frontendIds.appMasterSidebar.budget ) ? <li><Link to="/budget" onClick={ e=> this.menuItemClickHandler(e) }><img src="/images/icons/sidebar/budget.svg" alt="Budget"/><span>{Helper.getLabel(this.props.language,LabelsGUI_ID.sidepanel.budget,'Budget')}</span></Link></li> : ""}
    // place the above menu when done
    
    componentDidUpdate(prevProps) {
        $('.sidebar_menu').on('a','click',function(e){
         
           
        })
    }
    menuItemClickHandler(e){
        $('.sidebar_menu li').removeClass('active');
        $(e.target).parents('li').addClass('active')
    }
    render() {
        let sidebarStyle = {}; 
        
        if( this?.props?.appOptions?.options?.isSidebarOpen){
            sidebarStyle.width = '250px';
            sidebarStyle.background = '#21263D';
        }else {
            sidebarStyle.width = '0';
            sidebarStyle.overflow = "hidden";
            sidebarStyle.visibility = "hidden";
        }
  
        return (
            <div className='sidebar_section' style={sidebarStyle}>
                <div className='sidebar_section_inner'>
                    <Link className='main_logo rs_sticky_tag' onClick={ e=> this.menuItemClickHandler(e) } to={'/system-integration'}> <img src="/images/logo_white.svg" alt="Logo"/> </Link>
                    <ul className='sidebar_menu'>
                        { <li><Link to="/system-integration" onClick={ e=> this.menuItemClickHandler(e) }><img src="/images/icons/sidebar/command.svg" alt=""/><span>{ 'Integration Manager' }</span></Link></li> }
                    </ul>
                </div>
                
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        appOptions:state.options,
        language:state.language,
        vendor:state.vendor,
    }
}

export default connect(mapStateToProps) (Sidebar);